import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { Form, ModuleSearchField, useSettings, useUserData, Utils } from 'app/main/components';

interface CoursesAttendersAddDialogProps {
	model: any;
	updateRefresh: VoidFunction;
}

export const showCoursesAttendersAddDialog = (props: CoursesAttendersAddDialogProps) =>
	openDialog({
		children: <CoursesAttendersAddDialog {...props} />,
		maxWidth: 'xs',
		fullWidth: true,
		onClose: () => {}
	});

export function CoursesAttendersAddDialog({ model, updateRefresh }: CoursesAttendersAddDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const userData = useUserData();

	const [attenderUid, setAttenderUid] = React.useState();
	const handleChange = (_name, value) => setAttenderUid(value);

	function addAttender() {
		Utils.executeStored({
			action: `st_courses_users_add`,
			dispatch,
			data: {
				crus_user_uid: attenderUid,
				crus_crss_uid: model.crss_uid,
				crus_user_created_uid: userData.user_uid
			},
			successHandler: () => {
				dispatch(Utils.alertSuccessMsg(t));
				dispatch(closeDialog());
				if (updateRefresh) updateRefresh();
			}
		});
	}

	return (
		<>
			<DialogTitle>{t('DIALOG_ADD_ATTENDER_TITLE')}</DialogTitle>
			<DialogContent>
				<Form id="coursesAttendersAddDialog" onSubmit={addAttender}>
					<ModuleSearchField
						name="user_uid"
						label={t('MODULE_USERS_NAME')}
						module="users"
						isEdit
						sendChange={handleChange}
					/>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_BACK')}</Button>
				<Button type="submit" form="coursesAttendersAddDialog" color="secondary">
					{t('DIALOG_ACTION_CONFIRM')}
				</Button>
			</DialogActions>
		</>
	);
}
